import { useEffect, useState } from "react"
import { Link } from 'react-router-dom'
import { toast } from "react-toastify"
import ArtCard from "../components/ArtCard"
import { formatError, logError } from "../services/logging"
import { API_URL } from "../config/api"
import '../styles/portfolio.css'

const Portfolio = () => {
  const [artworks, setArtworks] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchArt = async () => {
      try {
        const resp = await fetch(`${API_URL}/api/artworks`, {
          method: "GET",
          credentials: "include",
        })
        const data = await resp.json()
        if (resp.ok) {
          setArtworks(data)
        } else {
          logError(data)
          toast.error(data.message || "Failed to fetch artworks.")
        }
      } catch (error) {
        logError(formatError(error))
        toast.error("An unexpected error occurred. Please try again.")
      } finally {
        setLoading(false)
      }
    }
    fetchArt()
  }, [])

  const isSingle = artworks.length === 1

  const mappedArt = artworks?.map(art => (
    <Link to={`/artwork/${art.id}`} key={`${art.id}-${art.prompt_id}-${art.image_type}`}>
      <ArtCard {...art} isSingle={isSingle} />
    </Link>
  ))

  return (
    <div className='container'>
      <h2>Portfolio</h2>

      {loading ? (
        <section>
            <p>Loading...</p>
        </section>
      ) : artworks.length > 0 ? (
          <>
            <p>{`${artworks.length} saved ${isSingle ? 'picture' : 'pictures'} here`}</p>
            <section className={`grid ${isSingle ? 'single-item' : ''}`}>
              {mappedArt}
            </section>
          </>
        ) : (
          <>
            <p>It looks like you haven't created any artwork yet. When you're ready, feel free to start by selecting a prompt.</p>
            <Link to="/prompts" className="button">
              Browse prompts and start creating
            </Link>
          </>
        )
      }
    </div>
  )
}

export default Portfolio